import $ from "cash-dom";

$(window).on("load", () => {
  function init() {
    const loadMoreButton = $("#load-more-button");
    const articlesContainer = $("#articles-container");
    const loadMoreContainer = $("#load-more-container");

    if (loadMoreButton.length) {
      loadMoreButton.on("click", function (event) {
        event.preventDefault();

        const button = $(this);
        const buttonText = button.find(".bof-button-text");
        const buttonLoader = button.find(".bof-button-loader");
        const currentPage = parseInt(button.data("current-page")) + 1;

        button.addClass("is-disabled");
        buttonText.hide();
        buttonLoader.show();

        const apiPath = button.data("api-path");
        const locale = button.data("locale") || "sv";

        const xhr = new XMLHttpRequest();
        xhr.open("GET", `${apiPath}?page=${currentPage}`, true);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              try {
                const data = JSON.parse(xhr.responseText);

                data.articles.forEach((article) => {
                  let ingressHtml = "";
                  if (article.ingress && article.ingress.trim() !== "") {
                    const sanitized = stripTags(article.ingress);
                    const truncated = truncateWords(sanitized, 20);
                    ingressHtml = truncated;
                  }

                  const articleHtml = `
                    <div class="bof-blog-item">
                      <div class="bof-blog-item-content">
                        ${
                          article.heroImage && article.heroImage.url
                            ? `
                          <div class="bof-blog-card-image">
                            <img class="bof-blog-card-image-figure" src="${
                              article.heroImage.url
                            }?w=640" alt="${
                                article.heroImage.alt || ""
                              }" loading="lazy" />
                          </div>
                        `
                            : ""
                        }
                        <p class="bof-blog-item-content-meta is-small">
                          ${
                            article._firstPublishedAt
                              ? formatDate(article._firstPublishedAt, locale)
                              : ""
                          } |
                          <span class="">
                            ${article.category?.name || ""}
                          </span>
                        </p>
                        <a href="/${locale}/articles/${
                    article.slug
                  }" class="bof-blog-item-content-linkarea">
                          <h3 class="bof-blog-item-content-title is-thicker">
                            ${article.title}
                          </h3>
                          <p class="bof-blog-item-content-ingress">
                            ${ingressHtml}
                          </p>
                        </a>
                        <a href="/${locale}/articles/${
                    article.slug
                  }" class="bof-blog-item-content-link is-grey is-small">
                          ${window.BOF_READ_MORE_TEXT}
                          <i class="bof-blog-item-content-link-icon fas fa-sharp fa-regular fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                  `;
                  articlesContainer.append(articleHtml);
                });

                button.data("current-page", currentPage);
                button[0].blur();

                if (!data.has_more) {
                  loadMoreContainer.hide();
                } else {
                  button.removeClass("is-disabled");
                  buttonText.show();
                  buttonLoader.hide();
                }
              } catch (error) {
                console.error("Error parsing JSON response:", error);
                button.removeClass("is-disabled");
                buttonText.show();
                buttonLoader.hide();
              }
            } else {
              console.error(
                "Error loading more articles:",
                xhr.status,
                xhr.statusText
              );
              button.removeClass("is-disabled");
              buttonText.show();
              buttonLoader.hide();
            }
          }
        };

        xhr.onerror = function () {
          console.error("Network error loading more articles");
          button.removeClass("is-disabled");
          buttonText.show();
          buttonLoader.hide();
        };

        xhr.send();
      });
    }
  }

  function stripTags(input) {
    if (!input) return "";
    return input.replace(/<\/?[^>]+(>|$)/g, "");
  }

  function truncateWords(str, numWords) {
    if (!str) return "";
    const words = str.split(/\s+/);
    if (words.length <= numWords) return str;
    return words.slice(0, numWords).join(" ") + "…";
  }

  function formatDate(dateString, locale) {
    const date = new Date(dateString);
    const monthNames = {
      en: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      sv: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december",
      ],
    };

    const month = monthNames[locale][date.getMonth()];
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
  }

  init();
});
